import "./style.scss";

import { KeyboardArrowRight } from "@mui/icons-material";
import { Tooltip } from "@mui/material";
import { SmallBody } from "helpers/TypographyComponents";
import { formatLocaleDateString } from "helpers/utils";
import { useTranslation } from "react-i18next";
import type { AgreementTemplate } from "store/agreementsStore";

interface IAgreementRow {
    /**
     * Agreement data
     */
    agreement: AgreementTemplate;
    /**
     * If is last added agreement template
     */
    isLastAddedTemplate: boolean;
    /**
     * Row index
     */
    index: number;
    /**
     * Open agreement drawer
     */
    handleOpenDrawer: (agreement: AgreementTemplate, isDefaultTemplate: boolean) => void;
}

const AgreementRow = ({ agreement, isLastAddedTemplate, index, handleOpenDrawer }: IAgreementRow) => {
    const isDefaultTemplate = index === 0;
    const [t] = useTranslation();
    const validatorsCount = agreement?.validators?.length;

    const renderValidatorsLabel = () => {
        const validatorNames = agreement.validators.map((user) => `${user?.firstname ?? ""}`);
        return validatorNames.join(", ");
    };

    return (
        <div className="agreement-row" onClick={() => handleOpenDrawer(agreement, isDefaultTemplate)}>
            <div className="agreement-row-head">
                <div className="agreement-row-left">
                    <div className="agreement-name-wrapper">
                        <h2 className="agreement-name">
                            {isDefaultTemplate ? t("ContractSettings.DefaultTemplate") : agreement.name}
                        </h2>
                    </div>
                    <SmallBody color="grey">
                        {t("ContractSettings.LastModified")}{" "}
                        {formatLocaleDateString({
                            date: agreement.modified,
                            options: { numeric: true, timeZone: "UTC" },
                        })}
                    </SmallBody>
                </div>
                <div className="agreement-row-right">
                    {isLastAddedTemplate && <div className="agreement-new-chip">{t("ContractSettings.New")}</div>}
                    {!!agreement.validators?.length && (
                        <Tooltip title={renderValidatorsLabel()}>
                            <div className="validators-chip">
                                <SmallBody style={{ fontWeight: "300" }}>
                                    {`${validatorsCount} ${t("ContractSettings.ValidatorsLabel")}${
                                        validatorsCount > 1 ? "s" : ""
                                    }`}
                                </SmallBody>
                            </div>
                        </Tooltip>
                    )}
                    <div className={`agreement-type-chip ${agreement.type ?? ""}`}>
                        {agreement.type === "avenant" && t("ContractSettings.TypeAvenant")}
                        {agreement.type === "framework_contract" && t("ContractSettings.TypeFrameworkContract")}
                        {(!agreement.type || agreement.type === "agreement") && t("ContractSettings.TypeAgreement")}
                    </div>
                    <KeyboardArrowRight />
                </div>
            </div>
        </div>
    );
};

export default AgreementRow;
